import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { sciIconModePostfix } from "@/const";

interface Props {
  fontSize: string | number | undefined;
  color: string;
  gradient: boolean;
}

export default Vue.extend({
  functional: true,
  name: "BaseIcon",
  props: {
    fontSize: { type: [String, Number] },
    color: { type: String },
    gradient: { type: Boolean, default: false },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    let { fontSize } = ctx.props;
    fontSize = typeof fontSize === "string" && !isNaN(parseFloat(fontSize)) ? parseFloat(fontSize) : fontSize;
    if (typeof fontSize === "number") fontSize = fontSize + "px";
    const slot = ctx.scopedSlots.default && ctx.scopedSlots.default(0);
    const iconName = !slot || !slot[0].text ? "" : slot[0].text.trim();
    if (!iconName) return { text: "", isComment: true, isRootInsert: false };
    const iconType = iconName.split("-")[0];
    if (
      /sci-color.*/.test(iconName) ||
      new RegExp(`sci-.*-(${sciIconModePostfix.DARK}|${sciIconModePostfix.LIGHT}).*`).test(iconName)
    ) {
      return (
        <img
          class={(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]).concat([
            iconType,
            iconName,
            ctx.data.staticClass,
          ])}
          style={(Array.isArray(ctx.data.style) ? ctx.data.style : [ctx.data.style]).concat([ctx.data.staticStyle])}
          on={ctx.listeners}
          src={`/img/icons/${iconName}.svg`}
        />
      );
    }
    return (
      <span
        class={(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]).concat([
          iconType,
          iconName,
          ctx.data.staticClass,
          ...(ctx.props.gradient ? ["__gradient"] : []),
        ])}
        style={(Array.isArray(ctx.data.style) ? ctx.data.style : [ctx.data.style]).concat([
          { fontSize, color: ctx.props.color },
          ctx.data.staticStyle,
        ])}
        on={ctx.listeners}
      />
    );
  },
});
